import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Body } from '../../Layouts/Body'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { appApi } from '../../../services/appApi'
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Divider, Flex, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { TimelineFeedback } from '../Timeline'
import { iItemFeedbackResponse, iNomeId, iParticipanteFeedbackResponse } from '../../../interfaces'
import { ModalDelete } from '../../../components/ModalDelete'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { ModalTag } from './Components/ModalTag'
import { ButtonTag } from './Components/ButtonTag'
import { EditorTexto } from '../../../components/EditorTexto/Index'
import { InputCmp } from '../../../components/InputCmp'
import { TableParticipantes } from './Components/TableParticipantes'
import { ModalIniciando } from './Components/ModalIniciando'
import { TableDataItens } from './Components/TableDataItens'
import { converterData, UpdateElementByPosition } from '../../../Utils/Helper'
import { CheckboxCmp } from '../../../components/CheckboxCmp'
import { MdGroup } from 'react-icons/md'
import { ModalGestaoPesquisa } from './Components/ModalGestaoPesquisa'
import { useInputsFormularioFeedback } from '../../../contexts/InputsContext/InputsFormularioFeedBackContext'

interface iModel {
  participantesFeedback: iParticipanteFeedbackResponse[]
  itemsFeedback: iItemFeedbackResponse[]
  dataInicio?: string
  textoEmail?: string
  iniciado?: boolean
  temPDI?: boolean
  temPesquisa?: boolean
  enviarAtrasados?: boolean
  intervaloDias?: number
}

export const EnvioFeedback: React.FC = () => {
  const { id } = useParams()
  const toast = useToast()
  const nav = useNavigate()
  const [IsLoading, setIsLoading] = useState(false)
  const [IsIniciando, setIsIniciando] = useState(false)
  const [IsLoadingColaboradores, setIsLoadingColaboradores] = useState(false)
  const [ModalTagIsOpen, setModalTagIsOpen] = useState(false)
  const [IniciarFeedbackIsOpen, setIniciarFeedbackIsOpen] = useState(false)
  const [ModalGestaoIsOpen, setModalGestaoIsOpen] = useState(false)
  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const { InputsFormularioFeedback, setInputsFormularioFeedback } =
    useInputsFormularioFeedback()
  const { resetInputsFormularioFeedback } = useInputsFormularioFeedback()

  const textPadrao = '<p>Olá, <strong>[NOME DO PARTICIPANTE]</strong>!</p><p>Você foi inserido no feedback <strong>[NOME DO FEEDBACK]</strong> que terá início no dia <strong>[DATA INICIO]</strong>.</p><p>Você pode acompanhar seu progresso na plataforma do SAH através do link abaixo:</p><p><strong>[LINK]</strong></p><p>A sua participação é fundamental para o sucesso dessa iniciativa.</p><p>Caso tenha dúvidas, por favor contatar o responsável pelo seu feedback através do email: <strong>[EMAIL DO GESTOR]</strong></p><p>Contamos com você!</p>'

  const [Model, setModel] = useState<iModel>(InputsFormularioFeedback)

  function getModel(dontChangeAll: boolean): void {
    setIsLoading(true)
    appApi.get(`FeedbackPersonalizado/${id}/Envio`)
      .then((res) => {
        const data: iModel = res.data
        if (dontChangeAll) {
          setModel({ ...Model, participantesFeedback: data.participantesFeedback })
        } else {
          if (data.iniciado) {
            setModel({ ...data, textoEmail: data.textoEmail ? data.textoEmail : textPadrao, dataInicio: data.dataInicio ? data.dataInicio?.split('T')[0] : undefined })
          } else {
            setModel({ ...Model, itemsFeedback: data.itemsFeedback, participantesFeedback: data.participantesFeedback, temPDI: data.temPDI, temPesquisa: data.temPesquisa })
          }
        }
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function getParticipanteById(partId: string): void {
    appApi.get(`FeedbackPersonalizado/${id}/Envio/Participante/${partId}`)
      .then((res) => {
        const data: iParticipanteFeedbackResponse = res.data
        const indexPart = Model.participantesFeedback.findIndex(e => e.id === partId)
        setModel({ ...Model, participantesFeedback: UpdateElementByPosition(Model.participantesFeedback, indexPart ?? 0, data) })
      })
      .catch(err => console.log(err))
  }

  function getColaboradores(): void {
    setIsLoadingColaboradores(true)
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoadingColaboradores(false))
  }

  function onIniciarFeedback(): void {
    if (Model?.textoEmail === '' || Model?.textoEmail === undefined || Model.textoEmail === null) {
      toast({
        title: 'O texto do email de aviso sobre o início do feedback está vazio, preencha o campo corretamente',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    setIsIniciando(true)
    appApi.put(`FeedbackPersonalizado/${id}/Iniciar`, { ...Model, participantesFeedback: [] })
      .then(() => {
        toast({
          title: 'Feedback iniciado com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        resetInputsFormularioFeedback()
        nav(`/Feedback/${id}/Dashboard`)
      })
      .catch(err => console.log(err))
      .finally(() => setIsIniciando(false))
  }

  function GetMensagensErroData(): string {
    if (Model.itemsFeedback.some((it) => it.ordem && it.dataInicio && CheckDateIsInvalid(it.fase, it.ordem, it.dataInicio))) return 'O campo de data de início deve respeitar a ordem dos itens, e manter um valor crescente desde as informações prévias até os itens para condução'

    if (Model.itemsFeedback.some(it => !it.dataInicio)) return 'Preencha todos os campos de data de início, das informações prévias e itens para condução'

    return ''
  }

  function CheckDateIsInvalid(fase: number, ordem?: number, dataInicio?: string): boolean {
    if (!ordem || !dataInicio) return false
    let dataMinima: Date
    const arr = Model.itemsFeedback.filter(e => e.fase === 0 && e.dataInicio)
    if (fase === 1 && arr.length > 0) {
      dataMinima = converterData(arr[arr.length - 1].dataInicio ?? '')
    }
    if (fase === 1 && ordem) {
      Model.itemsFeedback.filter(e => e.fase === 1 && e.dataInicio).forEach(e => {
        if (converterData(e.dataInicio ?? '') > dataMinima && e.ordem && e.ordem < ordem) {
          dataMinima = converterData(e.dataInicio ?? '')
        }
      })
    }

    return Model.itemsFeedback.filter(e => e.fase === fase).some(r => r.ordem && r.dataInicio && ((r.ordem < ordem && converterData(dataInicio) < converterData(r.dataInicio)) || (fase === 1 && converterData(dataInicio) < dataMinima)))
  }

  function OnChangeData(itens: Array<{ id?: string, novaDataInicio?: string }>): void {
    const copy: iItemFeedbackResponse[] = []
    Model.itemsFeedback.forEach(e => {
      const changeItem = itens.find(it => it.id === e.id)
      const newItem = { ...e }
      if (changeItem) {
        newItem.dataInicio = changeItem.novaDataInicio
      }

      copy.push(newItem)
    })
    setModel({
      ...Model,
      itemsFeedback: copy
    })
  }

  function SalvarAoVoltar(): void {
    setInputsFormularioFeedback(Model)
    nav(-1)
  }

  useEffect(() => {
    getModel(false)
    getColaboradores()
  }, [])

  useEffect(() => {
    if (Model.itemsFeedback.some((it) => CheckDateIsInvalid(it.fase, it.ordem, it.dataInicio))) {
      toast({
        title: GetMensagensErroData(),
        duration: 4000,
        position: 'top',
        status: 'error'
      })
    }
  }, [Model.itemsFeedback])

  return (
    <Body isLoading={IsLoading || IsLoadingColaboradores}>
      <ModalTag
        onClose={() => setModalTagIsOpen(false)}
        isOpen={ModalTagIsOpen}
      />
      <ModalGestaoPesquisa
        feedbackId={id ?? ''}
        isLoadingParticipantes={IsLoading}
        isOpen={ModalGestaoIsOpen}
        onGetParticipante={(partId) => getParticipanteById(partId)}
        onGetParticipantes={(val) => getModel(val)}
        onRequestClose={() => setModalGestaoIsOpen(false)}
        participantes={Model.participantesFeedback}
        temPDI={!!Model.temPDI}
      />
      <ModalDelete
        isOpen={IniciarFeedbackIsOpen}
        message={`Ao confirmar, o feedback será iniciado aos participantes pendentes${Model.iniciado ? '' : ', e não será mais possível alterar os itens de cada fase'}. Tem certeza de que deseja continuar?`}
        onConfirm={onIniciarFeedback}
        onRequestClose={() => setIniciarFeedbackIsOpen(false)}
        center
      />
      <ModalIniciando isOpen={IsIniciando}/>
      <TimelineFeedback id={id ?? ''}/>
      <Box>
        <Flex flexDir={'column'} mb={'1.25rem'} mt={'1rem'}>
          <h1>Gestão de envios</h1>
        </Flex>
        <Flex flexDir={'column'} gap={'1.25rem'}>
          {Model && <WhiteContainer>
            <Flex flexDir={'column'} gap={'1.25rem'}>
              <h3>Informações de envio</h3>
              <ElementoTooltipCmp bg={'var(--Red)'} label={Model.iniciado ? 'A data de início não pode ser alterada após o feedback ter sido iniciado' : ''}>
                <InputCmp
                  label='Início do feedback'
                  width={'100%'}
                  type={'date'}
                  isDisabled={Model.iniciado}
                  value={Model?.dataInicio ?? ''}
                  OnChange={(e) => setModel({ ...Model, dataInicio: e })}
                  borderColor='var(--Gray4)'
                />
              </ElementoTooltipCmp>
              <Divider opacity={'.7'} borderColor={'var(--c6)'} my={'.5rem'}/>
              <Flex flexDir={'column'}>
                <TableDataItens
                  rows={Model.itemsFeedback}
                  dataInicioFeedback={Model.dataInicio}
                  iniciado={Model.iniciado}
                  onChangeData={OnChangeData}
                />
                {GetMensagensErroData() !== '' && <Alert borderRadius={'.25rem'} justifyContent='space-between' status='warning' px={'.75rem'} py={'.75rem'} mt={'1rem'}>
                  <Flex flexDir={'column'} fontSize={'.75rem'}>
                    <Flex alignItems={'center'}>
                      <AlertIcon color={'#FF9900'} mr={'0.325rem'} h={'1.325rem'}/>
                      <AlertTitle lineHeight={'1.25rem'}>IMPORTANTE: </AlertTitle>
                      <AlertDescription lineHeight={'1.25rem'}>{GetMensagensErroData()}</AlertDescription>
                    </Flex>
                  </Flex>
                </Alert>}
                <Flex flexDir={'column'} gap={'.75rem'} mt={'1rem'}>
                  <CheckboxCmp isChecked={Model.enviarAtrasados} OnChange={(e) => setModel({ ...Model, enviarAtrasados: e, intervaloDias: e ? 7 : undefined })}>Enviar email de aviso quando houver itens em atraso</CheckboxCmp>
                  <ElementoTooltipCmp width={'30rem'} label={!Model.enviarAtrasados ? 'Habilite o campo de enviar email de aviso quando houver itens em atraso, para conseguir determinar o intervalo de dias em que eles serão disparados' : ''}>
                    <InputCmp label='Intervalo de dias em que os emails de aviso serão disparados' value={Model.intervaloDias ?? 0} OnChange={(e) => setModel({ ...Model, intervaloDias: parseInt(e) })} type={'number'} isDisabled={!Model.enviarAtrasados} width={'30rem'}/>
                  </ElementoTooltipCmp>
                </Flex>
              </Flex>
              <Divider opacity={'.7'} borderColor={'var(--c6)'} my={'.5rem'}/>
              <Flex flexDir={'column'}>
                <Flex justifyContent={'space-between'}>
                  <div style={{ maxWidth: '55rem', marginBottom: '1rem' }}>
                    <h3>Email de aviso sobre o início do feedback</h3>
                    <small>Esse é o texto que será enviado ao e-mail do participante avisando sobre o início do feedback</small>
                  </div>
                  <ButtonTag onClick={() => setModalTagIsOpen(true)}>Saiba como utilizar as TAGs</ButtonTag>
                </Flex>

                <EditorTexto isLoading={IsLoading} initialValue={Model.textoEmail ?? textPadrao}
                  onChange={(e: string) => setModel({
                    ...Model,
                    textoEmail: e
                  })} />
                <Flex justifyContent={'space-between'} marginTop='1rem'>
                <Flex w={'100%'} gap={'1rem'} justifyContent='space-between'>
                  <ButtonCmp
                    VarColor='c6'
                    onClick={() => {
                      setIsLoading(true)
                      setModel({
                        ...Model,
                        textoEmail: textPadrao
                      })
                      setTimeout(() => setIsLoading(false), 1000)
                    }}
                  >Restaurar texto padrão</ButtonCmp>
                </Flex>
                </Flex>
              </Flex>
            </Flex>
          </WhiteContainer>}
          {Model && <WhiteContainer margin='.5rem 0'>
              <Flex flexDir={'column'} gap={'1.25rem'} mb={'1rem'}>
                <Flex justifyContent={'space-between'}>
                  <h3>Lista de participantes</h3>
                  {Model.temPesquisa && <ButtonCmp leftIcon={<MdGroup/>} VarColor='Green2' onClick={() => setModalGestaoIsOpen(true)}>Alterar gestão de participantes para pesquisas</ButtonCmp>}
                </Flex>
                <TableParticipantes
                  iniciado={Model.iniciado}
                  colaboradores={Colaboradores}
                  onSend={() => {}}
                  rows={Model.participantesFeedback}
                />
              </Flex>
          </WhiteContainer>}
        </Flex>

        <Flex justifyContent={'end'} marginTop='1rem' gap={'.75rem'}>
          <ButtonCmp
            VarColor={'c6'}
            onClick={() => SalvarAoVoltar()}
          >Voltar</ButtonCmp>
          <ElementoTooltipCmp bg={'var(--Red)'} label={!Model?.dataInicio ? 'Selecione uma data de início para prosseguir com o inicio do Feedback' : GetMensagensErroData() !== '' ? GetMensagensErroData() : ''}>
            <ButtonCmp
              onClick={() => { if (Model.iniciado) { onIniciarFeedback() } else { setIniciarFeedbackIsOpen(true) } }}
              VarColor='Green2'
              isDisabled={!Model?.dataInicio || GetMensagensErroData() !== ''}
            >{Model.iniciado ? 'Iniciar Feedback para participantes pendentes' : 'Iniciar feedback'}</ButtonCmp>
          </ElementoTooltipCmp>
        </Flex>
      </Box>
    </Body>
  )
}
